module.exports = __webpack_public_path__ + "static/media/inBox.9d98d0a6.jpeg";